import { SessionContext } from '@Provider/index'
import { useContext } from 'react'

export default function useTenant() {
  const { sdk } = useContext(SessionContext)
  return sdk.tenant
}
